module.exports = __webpack_public_path__ + "media/images/countryrect/bo-f25dbb3b0f23fdb4ac0eb9a7079e49a4.svg";